import React, { useState, useEffect } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import funcionCambioURL from '../../../../funciones/gestionURL';

const PaginacionTabla = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const conseguirPaginaURL = () => {
        const params = new URLSearchParams(location.search);
        return parseInt(params.get('pagina')) || 1;
    };

    const [paginaActual, setPaginaActual] = useState(conseguirPaginaURL);
    const cambioURL = funcionCambioURL('pagina');

    useEffect(() => {
        setPaginaActual(conseguirPaginaURL);
    }, [location]);

    const handleChange = (event, value) => {
        setPaginaActual(value);
        const nuevaURL = cambioURL(value);
        navigate(nuevaURL);
    };

    return (
        <ContenedorPaginado spacing={2} convocatoria={props.convocatoria}>
            <Pagination
                count={props.totalPages}
                color="warning"
                shape="rounded"
                boundaryCount={1}
                siblingCount={0}
                page={paginaActual}
                onChange={handleChange}
            />
        </ContenedorPaginado>
    );
};

const ContenedorPaginado = styled(Stack)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left:  ${(props) => (props.isMobile ? '20%' : '')};
    width: ${(props) => (props.isMobile ? "200px":"")};
  

    .MuiPaginationItem-root.Mui-selected {
        background-color: ${(props) => (props.convocatoria ? 'rgb(238, 128, 93) !important' : 'rgba(0, 60, 102, 0.8) !important')};
        color: #fff !important;
    }
`;

export default PaginacionTabla;
